import React, { Component } from 'react'
import { observer } from 'mobx-react'

@observer
class DataTable extends Component {
    formatValue = (value, questionType, isCurrency, rowName, format) => {
        const { DataExplorerStore } = this.props
        const { getCurrencySymbol } = DataExplorerStore

        if (format === '%' || (['RD', 'CH', 'TB', 'SB', 'OD', 'PC'].includes(questionType) && !rowName.includes('footerRow-'))) {
            return `${value}%`
        }
        if (isCurrency && rowName !== 'footerRow-Total') {
            const currencySymbol = getCurrencySymbol()
            return `${currencySymbol}${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
        }
        return value
    }

    formatFooterRow = (questionType, rowName) => {
        if (questionType === 'NF' && rowName === 'footerRow-Average') return 'Sum'
        return rowName.replace('footerRow-', '')
    }

    renderData = () => {
        const { data } = this.props
        const rows = {}
        const orderedRows = new Set()
        const columns = data.products
            .map((p) => p.columns
                .map((c) => `${p.id}-${c.name}`)).flat()

        data.products
            .forEach((p) => p.columns.forEach((c) => {
                c.data.forEach((d) => {
                    if (!rows[d.name]) {
                        rows[d.name] = {}
                    }
                    rows[d.name] = {
                        ...rows[d.name],
                        [`${p.id}-${c.name}`]: d.value,
                    }
                    if (!d.hide) {
                        orderedRows.add(d.name)
                    }
                })
            }))
        let subIndex = -1
        let product = ''
        const badgeTypes = {
            0: 'success',
            1: 'archive',
            2: 'warning',
        }
        return [...orderedRows].map((r) => (
            <tr className="dataRow">
                <td className="br optionColumn">{this.formatFooterRow(data.questionType, r)}</td>
                {columns.map((c, i) => {
                    const curProduct = c.split('-')[0]
                    if (curProduct !== product || subIndex === 2) subIndex = -1
                    product = curProduct
                    subIndex += 1
                    return (
                        <td
                            className={i !== columns.length - 1 && curProduct !== columns[i + 1].split('-')[0] ? 'br' : ''}
                        >
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                {rows[r][c] === ''
                                    ? null
                                    : (
                                        this.formatValue(rows[r][c], data.questionType, data.isCurrency, r, data.format)
                                    )}
                            </div>
                        </td>
                    )
                })}
            </tr>
        ))
    }

    render() {
        const { data } = this.props
        const { DataExplorerStore } = this.props
        const { nonYears } = DataExplorerStore

        if (!data) return null
        const { name } = data
        return (
            <div className="dataTable">
                <table>
                    <thead>
                        <tr>
                            <th className="tableHeading" colSpan={data.products.reduce((colSpan, p) => p.columns.length + colSpan, 1)}>
                                {name}
                            </th>
                        </tr>
                    </thead>
                    <thead>
                        <tr className="eventHeadingRow">
                            <th className="eventHeading br optionColumn">Option</th>
                            {data.products.map((p) => (
                                <th className="eventHeading br" colSpan={p.columns.length}>{p.name}</th>
                            ))}
                        </tr>
                    </thead>
                    <thead>
                        <tr className="years">
                            <th className="yearHeading br"> </th>
                            {data.products.map((p) => p.columns.map((c, ci) => (
                                <th
                                    className={`yearHeading ${ci === p.columns.length - 1 ? 'br' : ''}`}
                                >
                                    {nonYears[c.name] || c.name}
                                </th>
                            ))).flat()}
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderData()}
                    </tbody>
                </table>
            </div>
        )
    }
}

export default DataTable
